/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper from "swiper";
import { Navigation } from "swiper/modules";
Swiper.use([Navigation]);
export function slider() {
    const referencesSliderSelector = ".references-slider__list-wrap.swiper";
    const latestArticlesSliderSelector = ".articles-list__wrap.swiper";
    const cardsSliderSelector = ".cards__list--wrap.swiper";

    const handleSlideChangeTransitionEnd = function (swiper) {
        //Fix the tabindex for accebility
        swiper.el
            .querySelectorAll(" .swiper-slide > a")
            .forEach((slide) => {
                slide.setAttribute("tabindex", "-1");
            });

        const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a"
        );
        if (activeSlide != null) {
            activeSlide.setAttribute("tabindex", "0");
        }
    };

    const handleSlideChange = function () {
        //Makes sure that the lazyloaded image on the duplicate slide has the right class so it doesnt show up as grey
        var nextDuplicateSlide = document.querySelector(".swiper-slide-duplicate.swiper-slide-next");
        if (nextDuplicateSlide != null) {
            var unloadedSlideImage = nextDuplicateSlide.querySelector("img.lazyloading");
            if (unloadedSlideImage != null) {
                unloadedSlideImage.classList.replace("lazyloading", "lazyloaded");
            }
        }
    }

    const init = function () {

        //Archive files sliders
        const referencesSliders = [];
        const referencesSliderElements = document.querySelectorAll(referencesSliderSelector);
        if (referencesSliderElements) {
            referencesSliderElements.forEach(slider => {

                referencesSliders.push(new Swiper(slider, {
                    speed: 500,
                    slidesPerView: 'auto',
                    watchOverflow:true,
                    breakpoints: {
                        480: {
                            spaceBetween: 30,
                        },
                        1500: {
                            spaceBetween: 40
                        }
                    },
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .slider-navigation__next",
                        prevEl: '#' + slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                }));
            })
        }

        //Latest articles sliders
        const latestArticlesSliders = [];
        const latestArticlesSlidersElements = document.querySelectorAll(latestArticlesSliderSelector);
        if (latestArticlesSlidersElements) {
            latestArticlesSlidersElements.forEach(slider => {

                latestArticlesSliders.push(new Swiper(slider, {
                    speed: 500,
                    slidesPerView: 'auto',
                    watchOverflow:true,
                    breakpoints: {
                        480: {
                            spaceBetween: 30,
                        },
                        1440: {
                            spaceBetween: 40
                        }
                    },
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .slider-navigation__next",
                        prevEl: '#' + slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                }));
            })
        }

        //Cards sliders
        const cardsSliders = [];
        const cardsSlidersElements = document.querySelectorAll(cardsSliderSelector);
        if (cardsSlidersElements) {
            cardsSlidersElements.forEach(slider => {

                cardsSliders.push(new Swiper(slider, {
                    slidesPerView: 'auto',
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .slider-navigation__next",
                        prevEl: '#' + slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                }));
            })
        }
    };

    init();
}
